import React from "react";
const TilteContext = React.createContext();
export default TilteContext;
